import React, { useState } from 'react';
import { useStyles } from 'components/Styles';
import {
  FormGroup, Grid, TextField, Tooltip, Typography,
  Autocomplete,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import MaskCEP from 'components/Masks/maskCEP';
import MaskPhone from 'components/Masks/maskPhone';
import HelpIcon from '@mui/icons-material/Help';

function FarmInfoOne(props) {
  const {
    formik, cities, states, selectedState, selectedCity, handleStateSelect, handleCitySelect,
  } = props;
  const classes = useStyles();

  function onBlurCep(cep) {
    fetch(`https://viacep.com.br/ws/${cep}/json/`)
      .then((res) => res.json())
      .then((data) => {
        const state = states.find((state) => state.sigla === data.uf);
        handleStateSelect(state);
        handleCitySelect({ nome: data.localidade });
        formik.setValues({
          ...formik.values,
          cep,
          street: data.logradouro,
          district: data.bairro,
        });
      });
  }

  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#FFFFFF',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 300,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #0367bf',
    },
  }))(Tooltip);

  return (
    <>
      <Typography
        style={{
          fontWeight: '700',
          fontSize: '28px',
          textAlign: 'left',
          marginTop: '0rem',
          position: 'absolute',
        }}
      >
        Endereço da Fazenda
      </Typography>
      <Typography
        style={{
          fontSize: '21px',
          textAlign: 'left',
          marginTop: '4rem',
          position: 'absolute',
        }}
      >
        Insira as informações da sua fazenda.
      </Typography>

      <FormGroup
        style={{ width: '110%', marginTop: '10rem', position: 'relative' }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
              <TextField
                fullWidth
                id="formGridCep"
                label="CEP"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                name="cep"
                type="text"
                value={formik.values.cep}
                onChange={formik.handleChange}
                InputProps={{
                  inputComponent: MaskCEP,
                }}
                onBlur={() => onBlurCep(formik.values.cep)}
                // onBlur={formik.handleBlur}
                error={formik.touched.cep && formik.errors.cep}
                helperText={formik.touched.cep && formik.errors.cep}
              />
          </Grid>
          <Grid item xs={12}>
            <Autocomplete
              noOptionsText="Sem opções"
              id="formGridState"
              name="state"
              options={states}
              value={selectedState}
              getOptionLabel={(options) => options.nome || ''}
              onChange={(p, v) => {
                handleStateSelect(v);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  error={formik.touched.state && formik.errors.state}
                  helperText={formik.touched.state && formik.errors.state}
                  label="Estado"
                  variant="outlined"
                  fullWidth
                />
              )}
              disableClearable
              size="medium"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <Autocomplete
              id="formGridCity"
              noOptionsText="Sem opções"
              name="city"
              options={cities}
              value={selectedCity}
              getOptionLabel={(options) => options.nome || ''}
              onChange={(p, v) => {
                handleCitySelect(v);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  error={Boolean(formik.touched.city && formik.errors.city)}
                  helperText={formik.touched.city && formik.errors.city}
                  label="Cidade"
                  variant="outlined"
                  fullWidth
                />
              )}
              disableClearable
              size="medium"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              id="formGridStreet"
              label={(
                <div>
                  Logradouro
                  {' '}
                  <HtmlTooltip
                    title={(
                      <>
                        Logradouro é uma rua; um endereço de espaço público ou privado.
                      </>
                    )}
                    placement="right"
                    arrow
                  >
                    <HelpIcon color="primary" fontSize="inherit" />
                  </HtmlTooltip>
                </div>
              )}
              variant="outlined"
              InputLabelProps={{
                style: { pointerEvents: 'auto' },
                shrink: true,
              }}
              name="street"
              type="text"
              value={formik.values.street}
              onChange={formik.handleChange}
              // onBlur={formik.handleBlur}
              error={formik.touched.street && formik.errors.street}
              helperText={formik.touched.street && formik.errors.street}
            />
          </Grid>
          <Grid item xs={8}>
            <TextField
              fullWidth
              id="formGridDistrict"
              label="Bairro"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              name="district"
              type="text"
              value={formik.values.district}
              onChange={formik.handleChange}
              // onBlur={formik.handleBlur}
              error={formik.touched.district && formik.errors.district}
              helperText={formik.touched.district && formik.errors.district}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              fullWidth
              id="formGridNumber"
              label="Número (Opcional)"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              name="number"
              type="text"
              value={formik.values.number}
              onChange={formik.handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <FormGroup>
              <TextField
                fullWidth
                id="phone"
                label="Telefone"
                placeholder="Telefone"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                name="phone"
                type="text"
                value={formik.values.phone}
                onChange={formik.handleChange}
                InputProps={{
                  inputComponent: MaskPhone,
                }}
                error={formik.touched.phone && formik.errors.phone}
                helperText={formik.touched.phone && formik.errors.phone}
              />
            </FormGroup>
          </Grid>
        </Grid>
      </FormGroup>
    </>
  );
}

export { FarmInfoOne };
